module.exports = __webpack_public_path__ + "media/VW_Skeeball_10pts_091120_enc-cs.d00fda9d.mp4";